import React from 'react';
import { ThreeDots } from 'react-loader-spinner';

import style from 'assets/scss/components/ReactLoader.module.scss';

const ReactLoader = () => {
  const { wrapper } = style;

  return (
    <div className={wrapper}>
      <ThreeDots {...{ color: '#304785', height: 100, width: 100 }} />
    </div>
  );
};

export default ReactLoader;
